module.exports = __webpack_public_path__ + "img/avatar2.68a9d85d.jpg";